import {gql} from '@apollo/client';

// The mutation returns the same fragment, so Apollo refreshes the holder from its result.
export const DEFAULT_BANK_ACCOUNT_CONTACT_FRAGMENT = gql`
  fragment DefaultBankAccountContact on ContactType {
    id
    simplifiedName
    defaultBankAccount {
      id
    }
  }
`;

export const GET_DEFAULT_BANK_ACCOUNTS = gql`
  query DefaultBankAccounts($accountId: UUID!) {
    defaultBankAccounts(accountId: $accountId) {
      isEnabled
      contacts {
        ...DefaultBankAccountContact
      }
    }
  }
  ${DEFAULT_BANK_ACCOUNT_CONTACT_FRAGMENT}
`;

export const UPDATE_DEFAULT_BANK_ACCOUNT = gql`
  mutation UpdateDefaultBankAccount(
    $accountId: UUID!
    $contactId: UUID!
    $bankAccountId: UUID!
  ) {
    updateDefaultBankAccount(
      accountId: $accountId
      contactId: $contactId
      bankAccountId: $bankAccountId
    ) {
      ok
      errors
      contact {
        ...DefaultBankAccountContact
      }
    }
  }
  ${DEFAULT_BANK_ACCOUNT_CONTACT_FRAGMENT}
`;
